const listItemParser = (text: string) => {
  const items = text.split('●');
  items.shift();
  return items;
};

export default listItemParser;
